document.addEventListener("DOMContentLoaded", function (){
// all slider
window.SplideSliderFunction = function () {
  document.querySelectorAll('.splide').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '0px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true'; // keep false
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type || 'slide';
    const paginatione = element.dataset.pagination === 'true';

    /* padding */
    const paddingLeft = element.dataset.paddingLeft
      ? element.dataset.paddingLeft + 'px'
      : 0;

    const paddingRight = element.dataset.paddingRight
      ? element.dataset.paddingRight + 'px'
      : 0;

    /* breakpoints */
    let breakpoints = {};
    if (element.dataset.breakpoints) {
      try {
        breakpoints = JSON.parse(element.dataset.breakpoints);
      } catch (e) {
        console.warn('Invalid breakpoints JSON', element.dataset.breakpoints);
      }
    }

    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows, // keep false to disable default arrows
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      interval: autoplayintervel || 3000,

      padding: {
        left: paddingLeft,
        right: paddingRight,
      },

      breakpoints: breakpoints,
    });

    /* ✅ Custom arrows */
const prevBtn = element.querySelector('.splide-custom-prev');
const nextBtn = element.querySelector('.splide-custom-next');

if (prevBtn) {
  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    splide.go('<');
  });
}

if (nextBtn) {
  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    splide.go('>');
  });
}
    /* Progress bar */
    const bar = element.querySelector('.my-carousel-progress-bar');
    if (bar) {
      splide.on('mounted move', function () {
        const totalPages = splide.Components.Controller.getEnd() + 1;
        const currentPage = splide.index + 1;
        bar.style.width = (currentPage / totalPages) * 100 + '%';
      });
    }

    splide.mount();
  });
};

SplideSliderFunction();

// Splide Slider End
});


// FAQ
document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq-item');
  if (faqItems.length) {
    faqItems[0].classList.add('active'); // Open first FAQ by default
  }
  faqItems.forEach(item => {
    const button = item.querySelector('.faq-question');
    button.addEventListener('click', () => {
      faqItems.forEach(i => {
        if (i !== item) i.classList.remove('active');
      });
      item.classList.toggle('active');
    });
  });
});